export default __webpack_public_path__ + "static/media/gas-station-fill.17e26806.svg";